export default "__VITE_ASSET__B0lOVqH4__"